import { DateTime } from 'luxon';

/** `2026-09-21` → `Mo, 21.09.2026`. Reine Anzeige; der Wert selbst ist immer `yyyy-MM-dd`. */
export function formatDeliveryDay(day: string): string {
  const date = DateTime.fromISO(day, { zone: 'Europe/Berlin' }).setLocale('de');
  return date.isValid ? date.toFormat('ccc, dd.MM.yyyy') : day;
}

/**
 * Warum für diesen Kunden kein Routenfahrplan gegriffen hat, in Worten für die Oberfläche.
 *
 * Der häufigste Grund ist `zone-ohne-fahrplan`: die Fahrplandatei ist eine reine DE-Liste,
 * sämtliche Auslandszonen stehen nicht darin.
 */
export const DELIVERY_FALLBACK_LABELS: Record<string, string> = {
  'kein-debitor': 'Kein Debitor erkannt',
  'firma-unbekannt': 'Firma nicht im Kundenstamm',
  'firma-ohne-zone': 'Keine Transportzone hinterlegt',
  'zone-ohne-fahrplan': 'Transportzone steht nicht im Routenfahrplan',
  'zone-inaktiv': 'Transportzone ist nicht mehr aktiv',
  'zone-ohne-transportzeit': 'Transportzone ohne Transportzeit',
  'zone-ohne-abfahrtstag': 'Transportzone ohne Abfahrtstag',
  'kein-abfahrtstag-im-horizont': 'Kein Abfahrtstag in den nächsten 90 Tagen',
};
